<div class="update-notification" *ngIf="showUpdateNotification">
  <div class="update-content">
    <div class="update-icon"><i class="ph ph-arrows-clockwise"></i></div>
    <div class="update-text">
      <h4 class="d-flex align-items-center gap-2">
        Update Available
        <span *ngIf="countdown > 0" class="countdown">({{ countdown }}s)</span>
      </h4>
      <p>A new version of the app is available. Update now to get the latest features and improvements.</p>
    </div>
    <div class="update-actions d-flex">
      <div class="col">
        <dk-button label="Update Now" (onClick)="updateNow()" />
      </div>
      <div class="col">
        <dk-button label="Later" severity="secondary" (onClick)="dismissNotification()" />
      </div>
    </div>
  </div>
</div>
